import { tLayout } from "../../translations";
import useThemeContextualColors, { sectionToParent } from "../../hooks/use-theme-contextual-colors";
import type { CrossSellBlockProps } from "./types";

const grey = "#e5e7eb";
const radius8 = "8px";
const radius4 = "4px";

function TitleBar() {
  return <div style={{ height: "12px", width: "70%", backgroundColor: grey, borderRadius: radius4 }} />;
}
function PriceBar() {
  return <div style={{ height: "12px", width: "40%", backgroundColor: grey, borderRadius: radius4 }} />;
}

function PlaceholderItem() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
      <div style={{ width: "100%", aspectRatio: "16 / 9", backgroundColor: grey, borderRadius: radius8 }} />
      <TitleBar />
      <PriceBar />
    </div>
  );
}

export function CrossSellWebEditor({ block, locale, defaultLocale, theme, section }: CrossSellBlockProps) {
  const count = block?.properties?.count ?? 2;
  const t = tLayout(locale, defaultLocale);
  const colors = useThemeContextualColors(theme, sectionToParent(section));

  const title = (
    <p style={{ margin: "0 0 8px", padding: 0, lineHeight: 1.4, fontWeight: 600, color: colors.text }}>
      {t("crossSell.youMightAlsoLike")}
    </p>
  );

  if (count === 1) {
    return (
      <div style={{ padding: "4px" }}>
        {title}
        <div style={{ maxWidth: "280px" }}>
          <PlaceholderItem />
        </div>
      </div>
    );
  }

  if (count === 2) {
    return (
      <div style={{ padding: "4px" }}>
        {title}
        <div style={{ display: "flex", gap: "8px" }}>
          <div style={{ flex: 1 }}><PlaceholderItem /></div>
          <div style={{ flex: 1 }}><PlaceholderItem /></div>
        </div>
      </div>
    );
  }

  if (count === 3) {
    return (
      <div style={{ padding: "4px" }}>
        {title}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
          <div style={{ gridColumn: 1, gridRow: 1 }}>
            <PlaceholderItem />
          </div>
          <div style={{ gridColumn: 1, gridRow: 2 }}>
            <PlaceholderItem />
          </div>
          <div style={{ gridColumn: 2, gridRow: "1 / 3", display: "flex", flexDirection: "column", gap: "6px" }}>
            <div style={{ flex: 1, backgroundColor: grey, borderRadius: radius8 }} />
            <TitleBar />
            <PriceBar />
          </div>
        </div>
      </div>
    );
  }

  // count === 4
  return (
    <div style={{ padding: "4px" }}>
      {title}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
        {([0, 1, 2, 3] as const).map((i) => (
          <PlaceholderItem key={i} />
        ))}
      </div>
    </div>
  );
}
